var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Exclude, Expose, Type } from 'class-transformer';
import { IsArray, IsDateString, IsObject, IsOptional, IsString, IsUUID } from 'class-validator';
import { ExercisePackageIconFullSizeDto } from './exercise-package-icon.full-size.dto.js';
import { ExerciseFullSizeDto } from './exercise.full-size.dto.js';
export class ExercisePackageFullSizeDto {
    id;
    createdAt;
    updatedAt;
    title;
    exercisePackageIconId;
    exercisePackageIcon;
    exercises;
}
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], ExercisePackageFullSizeDto.prototype, "id", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], ExercisePackageFullSizeDto.prototype, "createdAt", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], ExercisePackageFullSizeDto.prototype, "updatedAt", void 0);
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", String)
], ExercisePackageFullSizeDto.prototype, "title", void 0);
__decorate([
    IsUUID(),
    Expose(),
    IsOptional(),
    __metadata("design:type", Object)
], ExercisePackageFullSizeDto.prototype, "exercisePackageIconId", void 0);
__decorate([
    IsObject(),
    Type(() => ExercisePackageIconFullSizeDto),
    Expose(),
    __metadata("design:type", ExercisePackageIconFullSizeDto)
], ExercisePackageFullSizeDto.prototype, "exercisePackageIcon", void 0);
__decorate([
    IsArray(),
    Type(() => ExerciseFullSizeDto),
    Expose(),
    __metadata("design:type", Array)
], ExercisePackageFullSizeDto.prototype, "exercises", void 0);
//# sourceMappingURL=exercise-package.full-size.dto.js.map